import styled from 'styled-components';

export const DL = styled.dl`
  overflow: hidden;
  font-size: 13px;
  color: #7d7d7d;
  line-height: 24px;
  padding-top: 0;
  padding-bottom: 0;
  margin: 0;
  
  ${
    '' /* border-left: 1px solid ${props => props.theme.colors.secondary['gray-4']}; */
  }
  @media (max-width: ${props => `${props.theme.viewports.tablet}px`}) {
    border-color: transparent;
  }
  span {
    font-weight: bold;
    margin-right: 5px;
    &:last-child{
      margin-left: 5px;
    }
  }
`;

export const DT = styled.dt`
  font-weight: ${props => (props.bold ? '600' : 'normal')};
`;
